<template>
    <div class="flex w-full mt-6 leading-5 bg-gray-400 rounded-full">
        <button
            v-for="(tag, index) in tags"
            :key="index"
            @click="clicked(tag)"
            class="flex inline-flex items-center justify-center w-full px-2 py-2 text-base font-medium leading-5 bg-gray-400 rounded-full focus:outline-none "
            :class="{
                'text-gray-700  ': !tag.isActive,
                'bg-blue-600 outline-none text-white ': tag.isActive
            }"
        >
            {{ tag.name }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        tags: {
            type: Array,
            required: true
        }
    },
    methods: {
        clicked(payload) {
            this.tags.forEach(tag => {
                tag.isActive = false;
            });
            payload.isActive = true;
            this.$emit("clicked", payload.value);
        }
    }
};
</script>

<style></style>
